export const GET_LANGUAGE_SUCCESS = "GET_LANGUAGE_SUCCESS";

export const TOGGLE_THEME_MODE = "TOGGLE_THEME_MODE";

export const CHANGE_THEME_MODE = "CHANGE_THEME_MODE";
